import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import clsx from 'clsx';
import i18n from 'i18n-react';

import type { Amenity } from 'helpers/getListingAmenities';

import { decodeHtmlEntities } from '../../helpers/decodeHtmlEntities';
import c from './_profileAbout.module.scss';

export interface ProfileAboutProps {
  category: string | null;
  catName: string | null;
  starRating: string | null;
  cuisine: string | null;
  amenities: Amenity[];
}

export function ProfileAbout({ category, catName, starRating, cuisine, amenities }: ProfileAboutProps) {
  if (!category && !catName && !starRating && !cuisine && amenities.length === 0) return null;

  return (
    <div className={clsx('profile-about', c.wrapper)}>
      <div className={clsx('profile-about__title', c.title)}>
        <FontAwesomeIcon icon={['fas', 'info-circle']} /> {i18n.translate('directoryProfileView.about')}
      </div>
      {category && (
        <p className={clsx('profile-about__category', c.profileAboutSection)}>{decodeHtmlEntities(category)}</p>
      )}
      {catName && (
        <p className={clsx('profile-about__cat-name', c.profileAboutSection)}>{decodeHtmlEntities(catName)}</p>
      )}
      {starRating && (
        <p className={clsx('profile-about__star-rating', c.profileAboutSection)}>
          <span className={clsx('profile-about__star-rating-label', c.profileAboutStarRatingLabel)}>
            {i18n.translate('directoryProfileView.starRating')}
          </span>
          <br />
          {starRating}
        </p>
      )}
      {cuisine && (
        <p className={clsx('profile-about__cuisine', c.profileAboutSection)}>
          <span className={clsx('profile-about__cuisine-label', c.profileAboutCuisineLabel)}>
            {i18n.translate('directoryProfileView.cuisine')}
          </span>
          <br />
          {decodeHtmlEntities(cuisine)}
        </p>
      )}
      {amenities.length > 0 && (
        <ul className={clsx('profile-about__amenities', c.profileAboutSection, c.profileAboutAmenities)}>
          {amenities.map(({ column, label, icon }) => {
            return (
              <li key={column} className={clsx('profile-about__amenity', c.profileAboutAmenity)}>
                <FontAwesomeIcon
                  icon={icon}
                  fixedWidth
                  className={clsx('profile-about__amenity-icon', c.profileAboutAmenityIcon)}
                />{' '}
                {label}
              </li>
            );
          })}
        </ul>
      )}
    </div>
  );
}
